const styles = () => ({
  passwordPolicyLabel: {
    fontWeight: 600,
  },
  passwordPolicy: {
    "& span": {
      marginLeft: '-8px',
    },
  },
});

export default styles;